import { differenceInMinutes } from "date-fns";

import { File } from "types/types";

export const addDashes = (phone?: string) => {
  if (!phone) {
    return "";
  }
  if (phone.includes("-")) {
    return phone;
  }
  return phone.slice(0, 3) + "-" + phone.slice(3, 7) + "-" + phone.slice(7);
};

export const isFiveMinutesAgo = (date?: string) => {
  const now = new Date();
  if (!date) {
    return false;
  }
  const difference = differenceInMinutes(now, new Date(date));
  return difference <= 5;
};

export const fileUrl =
  "https://tzone.mimacstudy.com/admin/file/getFileDownload.ds?sysFileName";

export const downloadFile = (e: React.MouseEvent<HTMLElement>, file: File) => {
  e.preventDefault();
  window.open(
    `${fileUrl}=${file.filename}&uploadFileName=${encodeURI(encodeURI(file.upldfilename))}&filePath=${file.filepath}&disp=attachment`,
    "_blank",
  );
};

export function isImageUrl(filename: string) {
  const imageExtensions = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "webp",
    "svg",
    "ico",
    "tiff",
  ];

  try {
    const extension = filename.split(".").pop()?.toLowerCase?.();

    return imageExtensions.includes(extension ?? "");
  } catch (error) {
    return false;
  }
}

export function parseSearchString(search: string) {
  const params = new URLSearchParams(search);
  const result: Record<string, string> = {};
  Array.from(params.entries()).forEach(([key, value]) => {
    result[key] = value;
  });
  return result;
}
